import EspecialCardMenu from '../../../shared/components/especial_card_menu/especial_card_menu'
import { formatDecimalNumber } from "../../../services/helpers/formatDecimalNumber";
import { Link } from 'react-router-dom';
import property_img from "../../../assets/img/sinimagenunit.png";

function NewestProperties({ recentProperties, recentPropertiesError }) {
  return (
    <EspecialCardMenu className='mt-3' title='Propiedades Recientes'>
      {recentPropertiesError ? (
        <div className="col-12 col-md-12">
          <div className={'mt-3 alert fade show alert-warning'} role="alert">
            <strong>{recentPropertiesError}</strong>
          </div>
        </div>)
        :
        <div className='newest-properties-wrapper'>
          {
            recentProperties?.data?.
              filter((property) => property.price.value > 0 && property.price.value !== '')
              .map((property) => {
                return (
                  <Link key={property.id} className="text-decoration-none" to={"/cl/venta/" + property.publication_id}>
                    <div className="row mt-2 newest-properties-item" key={property.id}>
                      <div className="col-6">
                        {property.images.length ?
                          <img src={property.images[0].url} className="w-100 recent-properties-img" alt="Propiedad" />
                          :
                          <img src={property_img} className="w-100 recent-properties-img" alt="Propiedad" />
                        }
                      </div>
                      <div className="col-6 overflowX-hidden">
                        <span className='microcopy-bold property-type-label d-block'>
                          {property?.type.name}
                        </span>
                        <span className='microcopy-light text-black'>
                          {property.tittle !== '' && property.tittle!==null ?
                            property.tittle.replace(/Ref:\d+\*\*/i, '')
                            : property.address
                          }
                        </span>
                        <span className='subhead-bold text-black d-block mt-2'>
                          {`${property.price.currency.symbol}${formatDecimalNumber(property.price.value)}`}
                        </span>
                      </div>
                    </div>
                  </Link>
                )
              })
          }
        </div>
      }
    </EspecialCardMenu>
  )
}

export default NewestProperties
